module.exports = __webpack_public_path__ + "media/images/logo-07911c91030acb6528ba4b232b97cf38.png";